// LLM generated - Model Claude 4 Sonnet
import { useContext } from 'react';
import { createStyles } from '@mantine/core';

import { ContestChatModalContext } from './ContestChatModals/ContestChatModalContext';
import { ContestChat } from './ContestChat';

const useStyles = createStyles((theme) => ({
  panelContainer: {
    flex: 1,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.white,
    borderRadius: theme.other.spacing._8,
    overflow: 'hidden',
    minHeight: 0,
  },
}));

/**
 * ContestChatPanel - Wrapper for ContestChat when displayed as a side panel
 *
 * Note: This component no longer passes contestId/contestName/isCommissioner props
 * because ContestChat now gets all data from ContestChatContext (via ContestChatProvider)
 * This prevents duplicate API calls and Pusher subscriptions.
 */
export function ContestChatPanel() {
  const { classes } = useStyles();
  const { closeChatPanel } = useContext(ContestChatModalContext);

  return (
    <div className={classes.panelContainer}>
      <ContestChat
        isSidePanel // Desktop side panel - shows X button, no chat icon
        onModalClose={closeChatPanel}
      />
    </div>
  );
}
